module.exports = __webpack_public_path__ + "static/media/11NEPAD2.f0417350.jpg";